import { render, staticRenderFns } from "./homeowner-sidebar.vue?vue&type=template&id=352314d6"
import script from "./homeowner-sidebar.vue?vue&type=script&lang=js"
export * from "./homeowner-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports